import {mainServer} from '../../../../../variables/config.jsx'
import FileSaver from 'file-saver'
import axios from 'axios'

export const request_business_documents = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/businessdocument/"+id.toString());
  return response.data.data.tributary_mailbox_statuses;
}

export const request_outsourcing = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/outsourcing/"+id.toString())
  return response.data.data.outsourcing
}

export const request_add_outsourcings = async (id, data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.post("/outsourcing",data);
  let response;
  response = await mainServer.instance.get("/outsourcing/"+id.toString()+"/list")
  return response.data.data.outsourcing
}

export const request_edit_outsourcings = async (id, data, accountID) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.patch("/outsourcing/" + accountID, data);
  let response;
  response = await mainServer.instance.get("/outsourcing/"+id.toString())
  return response.data.data.outsourcing
}

export const request_delete_outsourcings = async (id, stampID) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.delete("/outsourcing/" + stampID);
  let response;
  response = await mainServer.instance.get("/outsourcing/"+id.toString())
  return response.data.data.outsourcing
}

/**************************************** */
export const request_users = async () => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/user/employee/list/");
  return response.data.data.employees
}

export const request_uploadFile = async(id, moduleID,path,file, ext, type) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let url = '/outsourcing/' + moduleID + '/' + path
  if(type)
    url = '/businessdocument/'+id+'/'+path;

  let response = await mainServer.instance.post(url, ext)
  const options = {headers: {'Content-Type': file.type}}
  delete axios.defaults.headers.common["Authorization"]
  response = await axios.put(response.data.data.path, file, options);
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  response = await mainServer.instance.get("/outsourcing/"+moduleID.toString())
  return response.data.data.outsourcing
}

export const request_downloadFile = async(id,moduleID, path, type) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  let url = 'outsourcing/' + moduleID + '/' + path
  if(type)
    url = '/businessdocument/'+id+'/'+path;
  response = await mainServer.instance.get(url)
  delete axios.defaults.headers.common["Authorization"]
  response = await axios.get(response.data.data.path, {responseType: 'blob'})
  FileSaver.saveAs(response.data, path)
}

export const request_deleteFile = async(id,moduleID, path, type) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response
  let url = 'outsourcing/' + moduleID + '/' + path
  if(type)
    url = '/businessdocument/'+id+'/'+path;
  await mainServer.instance.delete(url)
  
  response = await mainServer.instance.get("/outsourcing/"+moduleID.toString())
  return response.data.data.outsourcing
}